import { useEffect, useRef, useState } from "react";
import { Button, Form, Image, Modal } from "react-bootstrap";
// import "../../../styles/Employees/employeelist.scss";
import "../../../styles/Employees/employeeLasttracked.scss"


import { Employee } from "./utils";

import FilterComponent from "../FilterComponent";
// import FilterComponent from "../FilterComponent";
import { useNavigate } from "react-router";



import { commonGetService } from "../../../utils/properties";
// import { commonGetService } from "../../../utils/properties";

import { useAppDispatch,useAppSelector } from "../../../app/hooks";
// import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { setDepartmentLists, setDepartmentOptionsLists, setDesignationLists, setDesignationOptionsLists, setEmployeeSearch, setEmployeeStatusLists, setSystemStatusLists } from "../../../features/employee/employeeListSlice";
import { Pagination, PaginationProps } from "antd";

import { FilterOptions } from "../../../pages/EmployeeOverview";
// import { FilterOptions } from "../../../pages/EmployeeOverview";

const formatLastActivity = (value?: string) => {
    if (!value || value === "N/A") return "N/A";
    const date = new Date(value);
    if (isNaN(date.getTime())) return "N/A";
    return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
    });
};
export interface FilterOption {
    filterValue: string;
    isSelect: boolean;
    value?: string;
    title?: string;
}

const EmployeeLasttracked = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const employeeListData = useAppSelector((state) => state.employeeList);
    const controllerRef = useRef<AbortController | null>(null);

    // Role check — only admins see Last Tracked At / Last Screenshot At columns
  //  const isAdmin = localStorage.getItem("role")?.toLowerCase() === "admin";

    const [departmentOptions, setDepartmentOptions] = useState<FilterOption[]>([]);
    const [designationOptions, setDesignationOptions] = useState<FilterOption[]>([]);

    const [systemStatus, setSystemStatus] = useState<FilterOption[]>([
        { filterValue: "Online", isSelect: false },
        { filterValue: "Offline", isSelect: false },
        { filterValue: "Yet to Track", isSelect: false },
    ]);
    const [employeeStatus, setEmployeeStatus] = useState<FilterOption[]>([
        { filterValue: "Active", isSelect: false },
        { filterValue: "Exited", isSelect: false },
    ]);

    const [empStatusSelected, setEmpStatusSelected] = useState<string[]>([]);
    const [systemStatusSelected, setSystemStatusSelected] = useState<string[]>([]);
    const [designationSelected, setDesignationSelected] = useState<string[]>([]);
    const [departmentSelected, setDepartmentSelected] = useState<string[]>([]);
    const [employees, setEmployees] = useState<Employee[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [searchText, setSearchText] = useState<string>(employeeListData?.search || "");

    const [current, setCurrent] = useState<number>(1);
    const [totalEmployees, setTotalEmployees] = useState<number>(0);
    // For non-admins, only show these columns if at least one row actually has data
    // const hasLastTrackedData = employees.some(
    //     (e) => e.last_track_activity && e.last_track_activity !== "N/A"
    // );
    // const hasLastScreenshotData = employees.some(
    //     (e) => e.last_screenshot_time && e.last_screenshot_time !== "N/A"
    // );

    // const showLastTracked = isAdmin || hasLastTrackedData;
    // const showLastScreenshot = isAdmin || hasLastScreenshotData;
    // const visibleColCount = 8 + (showLastTracked ? 1 : 0) + (showLastScreenshot ? 1 : 0);

    // Tablet filter modal state
    const [showFilterModal, setShowFilterModal] = useState<boolean>(false);

    // Which dropdown panel is currently open (only one at a time)
    const [openDropdown, setOpenDropdown] = useState<string | null>(null);

    // Temp state for modal (applied only on "Apply")
    const [tempDepartmentOptions, setTempDepartmentOptions] = useState<FilterOption[]>([]);
    const [tempDesignationOptions, setTempDesignationOptions] = useState<FilterOption[]>([]);
    const [tempSystemStatus, setTempSystemStatus] = useState<FilterOption[]>([]);
    const [tempEmployeeStatus, setTempEmployeeStatus] = useState<FilterOption[]>([]);

    const openFilterModal = () => {
        setTempDepartmentOptions(departmentOptions.map((o) => ({ ...o })));
        setTempDesignationOptions(designationOptions.map((o) => ({ ...o })));
        setTempSystemStatus(systemStatus.map((o) => ({ ...o })));
        setTempEmployeeStatus(employeeStatus.map((o) => ({ ...o })));
        setOpenDropdown(null);
        setShowFilterModal(true);
    };

    const handleModalCancel = () => {
        setShowFilterModal(false);
        setOpenDropdown(null);
    };

    const handleModalApply = () => {
        setDepartmentOptions(tempDepartmentOptions);
        setDesignationOptions(tempDesignationOptions);
        setSystemStatus(tempSystemStatus);
        setEmployeeStatus(tempEmployeeStatus);
        setDepartmentSelected(
            tempDepartmentOptions.filter((o) => o.isSelect).map((o) => o.value).filter((v): v is string => v !== undefined)
        );
        let list = tempDepartmentOptions.filter((o) => o.isSelect).map((o) => o.value);
        dispatch(setDepartmentLists(list as string[]));

        setDesignationSelected(
            tempDesignationOptions.filter((o) => o.isSelect).map((o) => o.value).filter((v): v is string => v !== undefined)
        );
        let list1 = tempDesignationOptions.filter((o) => o.isSelect).map((o) => o.value);
        dispatch(setDesignationLists(list1 as string[]));
        setSystemStatusSelected(
            tempSystemStatus.filter((o) => o.isSelect).map((o) => o.filterValue)
        );
        let list2 = tempSystemStatus.filter((o) => o.isSelect).map((o) => o.value);
        dispatch(setSystemStatusLists(list2 as string[]));
        setEmpStatusSelected(
            tempEmployeeStatus.filter((o) => o.isSelect).map((o) => o.filterValue)
        );
        let list3 = tempEmployeeStatus.filter((o) => o.isSelect).map((o) => o.value);
        dispatch(setEmployeeStatusLists(list3 as string[]));

        setCurrent(1);
        setShowFilterModal(false);
        setOpenDropdown(null);
    };

    const handleClearAll = () => {
        setDepartmentOptions((prev) => prev.map((o) => ({ ...o, isSelect: false })));
        setSystemStatus((prev) => prev.map((o) => ({ ...o, isSelect: false })));
        setEmployeeStatus((prev) => prev.map((o) => ({ ...o, isSelect: false })));
        setDesignationOptions((prev) => prev.map((o) => ({ ...o, isSelect: false })));
        setDepartmentSelected([]);
        setDesignationSelected([]);
        setEmpStatusSelected([]);
        setSystemStatusSelected([]);
        dispatch(setDepartmentLists([]));
        dispatch(setDesignationLists([]));
        dispatch(setSystemStatusLists([]));
        dispatch(setEmployeeStatusLists([]));
        setCurrent(1);
    };

    const tableRows = employees; // server already applied search + filters


    // const tableRows = employees.filter((emp) => {
    //     return (
    //         emp.employee_id.toString().includes(searchText) ||
    //         emp.employee_name.toLowerCase().includes(searchText.toLowerCase()) ||
    //         emp.department.toLowerCase().includes(searchText.toLowerCase())
    //     );
    // });


    const staticLastTrackedData: Record<string, { date: string; ago: string }> = {
    "SW-100": { date: "Today, 09:14 AM", ago: "1 hr 28m ago" },
    "SW-101": { date: "Yesterday, 11:40 AM", ago: "1 day ago" },
    "SW-102": { date: "Yesterday, 12:54 PM", ago: "1 day ago" },
    "SW-103": { date: "01-Aug-2026, 02:03 PM", ago: "2 day ago" },
    "SW-104": { date: "01-Aug-2026, 04:12 PM", ago: "1 day ago" },
    "SW-105": { date: "02-Aug-2026, 02:14 PM", ago: "3 days ago" },
    "SW-106": { date: "02-Aug-2026, 03:30 PM", ago: "3 days ago" },
    "SW-107": { date: "02-Aug-2026, 04:14 PM", ago: "3 days ago" },
};

    useEffect(() => {
        commonGetService(`/api/1.0/role/departments`).then((res) => {
            if (res.status === 200) {
                let options: FilterOption[] = [];
                res.data.forEach((item: any) => {
                    options.push({ filterValue: item.label, isSelect: false, value: item.value });
                });
                if (employeeListData?.departmentLists.length > 0) {
                    options.map((item: any) => {
                        employeeListData?.departmentLists.includes(item.value) && (item.isSelect = true)
                    })
                    setDepartmentSelected(options.filter((o) => o.isSelect).map((o) => o.value).filter((v): v is string => v !== undefined))
                }

                setDepartmentOptions(options);
                // options = options.map((o) => ({ ...o, title: o.filterValue, key: o.value }));
                // dispatch(setDepartmentOptionsLists(options as FilterOptions[]));

            } else {
                setDepartmentOptions([]);
            }
        });
        commonGetService(`/api/1.0/employee/designations`).then((res) => {
            if (res.status === 200) {
                let options: FilterOption[] = [];
                res.data.forEach((item: any) => {
                    options.push({ filterValue: item.label, isSelect: false, value: item.value });
                });
                if (employeeListData?.designationLists.length > 0) {
                    options.map((item: any) => {
                        employeeListData?.designationLists.includes(item.value) && (item.isSelect = true)
                    })
                    setDesignationSelected(options.filter((o) => o.isSelect).map((o) => o.value).filter((v): v is string => v !== undefined))
                }
                setDesignationOptions(options);
                // options = options.map((o) => ({ ...o, title: o.filterValue, key: o.value }));
                // dispatch(setDesignationOptionsLists(options as FilterOptions[]));
            } else {
                setDesignationOptions([]);
            }
        });
        if (employeeListData?.systemStatusLists.length > 0) {
            let sys = systemStatus.map((item: any) => {
                const newItem = { ...item };
                if (employeeListData?.systemStatusLists.includes(item.filterValue)) {
                    newItem.isSelect = true;
                }
                return newItem;
            });
            setSystemStatusSelected(sys.filter((o) => o.isSelect).map((o) => o.filterValue));
            setSystemStatus(sys);
        }
        if (employeeListData?.employeeStatusLists.length > 0) {
            let emp = employeeStatus.map((item: any) => {
                const newItem = { ...item };
                if (employeeListData?.employeeStatusLists.includes(item.filterValue)) {
                    newItem.isSelect = true;
                }
                return newItem;
            })
            setEmpStatusSelected(emp.filter((o) => o.isSelect).map((o) => o.filterValue));
            setEmployeeStatus(emp);
        }

    }, []);

    const [debouncedSearch, setDebouncedSearch] = useState<string>(employeeListData?.search || "");

useEffect(() => {
    const handler = setTimeout(() => {
        setDebouncedSearch(searchText);
        setCurrent(1); // go back to page 1 whenever the search term changes
    }, 400);
    return () => clearTimeout(handler);
}, [searchText]);


useEffect(() => {
    if (controllerRef.current) {
        controllerRef.current.abort();
    }

    controllerRef.current = new AbortController();
    const { signal } = controllerRef.current;

    const page = current - 1 >= 0 ? current - 1 : 0;
    let endpoint = `/api/1.0/employee/last-track-activity?page=${page}&size=10`;

    if (empStatusSelected.length > 0) {
        endpoint += `&emp_status=${empStatusSelected.join(",")}`;
    }
    if (systemStatusSelected.length > 0) {
        endpoint += `&current_status=${systemStatusSelected.join(",")}`;
    }
    if (designationSelected.length > 0) {
        endpoint += `&designation_ids=${designationSelected.join(",")}`;
    }
    if (departmentSelected.length > 0) {
        endpoint += `&department_ids=${departmentSelected.join(",")}`;
    }
    if (debouncedSearch.trim()) {
        endpoint += `&search=${encodeURIComponent(debouncedSearch.trim())}`;
    }

    commonGetService(endpoint, signal).then((res) => {
        if (res.status === 200) {
            setEmployees(res.data?.content ?? []);
            setTotalEmployees(res.data?.totalElements ?? 0);
            setIsLoading(false);
        } else if (res.status !== "cancelled") {
            setEmployees([]);
            setTotalEmployees(0);
            setIsLoading(false);
        }
    });

    return () => {
        if (controllerRef.current) {
            controllerRef.current.abort();
        }
    };
}, [departmentSelected, designationSelected, systemStatusSelected, empStatusSelected, current, debouncedSearch]);


    const hasActiveFilters =
        employeeListData?.departmentLists.length > 0 || employeeListData?.designationLists.length > 0 || employeeListData?.systemStatusLists.length > 0 ||
        employeeListData?.employeeStatusLists.length > 0;

    // Toggle open/close a dropdown panel
    const toggleDropdown = (key: string) => {
        setOpenDropdown((prev) => (prev === key ? null : key));
    };

    //pagination
    const onPageChange: PaginationProps['onChange'] = (page) => {
        setCurrent(page);
    };

    // Toggle a single checkbox in temp state
    const toggleTempOption = (
        setter: React.Dispatch<React.SetStateAction<FilterOption[]>>,
        key: "value" | "filterValue",
        keyVal: string
    ) => {
        setter((prev) =>
            prev.map((o) =>
                (key === "value" ? o.value : o.filterValue) === keyVal
                    ? { ...o, isSelect: !o.isSelect }
                    : o
            )
        );
    };

    // Reusable dropdown-with-checkboxes component (defined inside to share scope)
    const FilterDropdown = ({
        id,
        label,
        placeholder,
        options,
        setter,
        optionKey,
    }: {
        id: string;
        label: string;
        placeholder: string;
        options: FilterOption[];
        setter: React.Dispatch<React.SetStateAction<FilterOption[]>>;
        optionKey: "value" | "filterValue";
    }) => {
        const isOpen = openDropdown === id;
        const selectedItems = options.filter((o) => o.isSelect);
        const selectedCount = selectedItems.length;

        const removeChip = (e: React.MouseEvent, keyVal: string) => {
            e.stopPropagation(); // prevent dropdown from toggling
            toggleTempOption(setter, optionKey, keyVal);
        };

        return (
            <Form.Group className="mb-3 filter-dropdown-group">
                <Form.Label>{label}</Form.Label>
                <div className={`filter-dropdown${isOpen ? " open" : ""}`}>
                    {/* Trigger */}
                    <button
                        type="button"
                        className={`filter-dropdown-trigger${selectedCount > 0 ? " has-chips" : ""}`}
                        onClick={() => toggleDropdown(id)}
                    >
                        <span className="trigger-chips-area">
                            {selectedCount > 0 ? (
                                selectedItems.map((o) => {
                                    const keyVal = optionKey === "value" ? (o.value ?? "") : o.filterValue;
                                    return (
                                        <span key={keyVal} className="filter-chip">
                                            <span className="chip-label">{o.filterValue}</span>
                                            <span
                                                className="chip-remove"
                                                onClick={(e) => removeChip(e, keyVal)}
                                            >
                                                <svg
                                                    width="16"
                                                    height="16"
                                                    viewBox="0 0 16 16"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        clipRule="evenodd"
                                                        d="M12.3536 3.64645C12.5488 3.84171 12.5488 4.15829 12.3536 4.35355L8.7071 8L12.3536 11.6465C12.5488 11.8417 12.5488 12.1583 12.3536 12.3536C12.1583 12.5488 11.8417 12.5488 11.6464 12.3536L8 8.70711L4.35355 12.3536C4.15829 12.5488 3.84171 12.5488 3.64645 12.3536C3.45118 12.1583 3.45118 11.8417 3.64645 11.6464L7.29289 8L3.64645 4.35356C3.45119 4.1583 3.45119 3.84172 3.64645 3.64645C3.84171 3.45119 4.15829 3.45119 4.35355 3.64645L8 7.2929L11.6464 3.64645C11.8417 3.45118 12.1583 3.45118 12.3536 3.64645Z"
                                                        fill="#A0A4A8"
                                                    />
                                                </svg>
                                            </span>
                                        </span>
                                    );
                                })
                            ) : (
                                <span className="trigger-placeholder">{placeholder}</span>
                            )}
                        </span>
                        <span className="trigger-right">
                            <svg
                                className={`dropdown-chevron${isOpen ? " rotated" : ""}`}
                                width="16"
                                height="16"
                                viewBox="0 0 16 16"
                                fill="none"
                            >
                                <path
                                    d="M4 6L8 10L12 6"
                                    stroke="#6d6d6d"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    </button>

                    {/* Options panel */}
                    {isOpen && (
                        <div className="filter-dropdown-panel">
                            {options.length === 0 ? (
                                <p className="no-options-text">No options available</p>
                            ) : (
                                options.map((o) => {
                                    const keyVal =
                                        optionKey === "value" ? (o.value ?? "") : o.filterValue;
                                    return (
                                        <label
                                            key={keyVal}
                                            className={`dropdown-checkbox-row${o.isSelect ? " checked" : ""}`}
                                            onClick={() => toggleTempOption(setter, optionKey, keyVal)}
                                        >
                                            <span className={`custom-checkbox${o.isSelect ? " checked" : ""}`}>
                                                {o.isSelect && (
                                                    <svg width="10" height="8" viewBox="0 0 10 8" fill="none">
                                                        <path
                                                            d="M1 4L3.5 6.5L9 1"
                                                            stroke="#fff"
                                                            strokeWidth="1.5"
                                                            strokeLinecap="round"
                                                            strokeLinejoin="round"
                                                        />
                                                    </svg>
                                                )}
                                            </span>
                                            <span className="dropdown-checkbox-label">{o.filterValue}</span>
                                        </label>
                                    );
                                })
                            )}
                        </div>
                    )}
                </div>
            </Form.Group>
        );
    };

    return (
        <div className="emp-container">
            {isLoading ? (
                <div className="d-flex justify-content-center align-items-center h-100 w-100 crt-loader">
                    <img src="/images/loader/content_loader.gif" />
                </div>
            ) : (
                <div className="list-emp-contaniner d-flex flex-column">
                    <div className="d-flex flex-column">
                        {/* Header row */}
                        <div className="d-flex justify-content-between align-items-center">
                            <h3>Employee Last Tracked</h3>
                            <Button className="export-btn-list-emp desktop-export-btn custom-export-btn" disabled={true}>
                                <Image src="/images/employees/download_icon.svg" alt="Download" />
                                Export
                            </Button>
                        </div>

                        {/* Search bar row */}
                        <div className="search-and-actions">
                            <div className="search-bar">
                                <Form.Control
                                    type="text"
                                    placeholder="Search employees by name, ID, or department"
                                    value={searchText}
                                    name="employee-filter"
                                    onChange={(e) => { setSearchText(e.target.value); dispatch(setEmployeeSearch(e.target.value)) }}
                                />
                                <Image
                                    src="/images/dashboard/grey_search.svg"
                                    alt="Search_Icon"
                                    className="position-absolute"
                                />
                            </div>

                            {/* Tablet-only action buttons */}
                            <div className="tablet-actions">
                                <Button className="tablet-filter-btn" onClick={openFilterModal}>
                                    <Image src="/images/employees/filtericon.svg" alt="Filter" />
                                    Filter
                                    {hasActiveFilters && (
                                        <span className="filter-badge">
                                            {employeeListData?.employeeStatusLists.length +
                                                employeeListData?.systemStatusLists.length +
                                                employeeListData?.designationLists.length +
                                                employeeListData?.departmentLists.length}
                                        </span>
                                    )}
                                </Button>
                                <Button className="export-btn-list-emp custom-export-btn" disabled={true}>
                                    <Image src="/images/employees/download_icon.svg" alt="Download" />
                                    Export
                                </Button>
                            </div>
                        </div>

                        {/* Desktop-only inline filters */}
                        <div className="fltr-fld-cont desktop-filters">
                            <div className="fltr-fld">
                                <FilterComponent
                                    filterBy="Department"
                                    filterTitle="Select Department"
                                    filterOptions={departmentOptions}
                                    filterType="checkbox"
                                    onApply={(updatedOptions) => {
                                        setDepartmentOptions([...updatedOptions]);
                                        const selected = updatedOptions
                                            .filter((o) => o.isSelect)
                                            .map((o) => o.value)
                                            .filter((v): v is string => v !== undefined);
                                        setDepartmentSelected(selected);
                                        dispatch(setDepartmentLists(selected));
                                        setCurrent(1);
                                    }}
                                />
                                <FilterComponent
                                    filterBy="Designation"
                                    filterTitle="Select Designation"
                                    filterOptions={designationOptions}
                                    filterType="checkbox"
                                    onApply={(updatedOptions) => {
                                        setDesignationOptions([...updatedOptions]);
                                        const selected = updatedOptions
                                            .filter((o) => o.isSelect)
                                            .map((o) => o.value)
                                            .filter((v): v is string => v !== undefined);
                                        setDesignationSelected(selected);
                                        dispatch(setDesignationLists(selected));
                                        setCurrent(1);
                                    }}
                                />
                                <FilterComponent
                                    filterBy="System Status "
                                    filterTitle="Select Status"
                                    filterOptions={systemStatus}
                                    filterType="checkbox"
                                    onApply={(updatedOptions) => {
                                        setSystemStatus(updatedOptions);
                                        const selected = updatedOptions
                                            .filter((o) => o.isSelect)
                                            .map((o) => o.filterValue);
                                        setSystemStatusSelected(selected);
                                        dispatch(setSystemStatusLists(selected));
                                        setCurrent(1);
                                    }}
                                />
                               
                            </div>
                            {hasActiveFilters && (
                                <div className="clr-txt" onClick={handleClearAll}>
                                    Clear All
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Employee table */}
                    <div className="emp-list w-100 common-scroll mx-auto styled-scroll-hor">
                        <table className="w-100">
                            <thead>
                                <tr>
                                    <th>Emp ID</th>
                                    <th>Employee Name</th>
                                    <th>Department</th>
                                    <th>Designation</th>
                                    <th>Last Tracked Time</th>
                                      <th>System Status</th>
                                    {/* <th>Device ID</th> */}
                                    {/* <th>Device OS</th> */}
                                    {/* <th>Emp Status</th> */}
                                    {/* {showLastTracked && <th>Last Tracked At</th>}
                                    {showLastScreenshot && <th>Last Screenshot At</th>} */}
                                </tr>
                            </thead>
                            <tbody>
                                {tableRows.length ? (
                                    tableRows.map((item) => (
                                        // <tr
                                        //     onClick={() => navigate(`/employeeOverview/${item.employee_id}`)}
                                        //     key={item.employee_id}
                                        // >
                                        <tr
                                            // onClick={() => navigate('/employeeOverview', { state: { empCode: item.employee_id } })}
                                            // key={item.employee_id}
                                        >
                                            <td>{item.employee_id}</td>
                                            <td>
                                                <div className="d-flex">
                                                    {item.employee_image ? <div className="image-wrapper">
                                                        <Image src={item.employee_image} alt="emp" className="emp-img" key={item.employee_image} />
                                                    </div>

                                                        : <div
                                                            className={item.employee_image ? "pro-pic" : "pro-pic fill-color-avatar"}
                                                        >     <span>{item.employee_name.charAt(0).toUpperCase()}</span></div>
                                                    }
                                                    <span>
                                                        <p className="emp-name" title={item.employee_name}>
                                                            {item.employee_name}
                                                        </p>
                                                        <p title={item.employee_mail}>{item.employee_mail}</p>
                                                    </span>
                                                </div>
                                            </td>
                                         
                                            <td title={item.department}>{item.department}</td>
                                            <td title={item.designation}>{item.designation}</td>
                                            {/* <td className="last-tracked-time">
                                                {staticLastTrackedData[item.employee_id] ? (
                                                    <>
                                                        <p className="tracked-date">
                                                            {staticLastTrackedData[item.employee_id].date}
                                                        </p>
                                                        <p className="tracked-ago">
                                                            {staticLastTrackedData[item.employee_id].ago}
                                                        </p>
                                                    </>
                                                )
                                                 : (
                                                    "-"
                                                )
                                                }
                                            </td> */}
                                            <td className="last-tracked-time">
                                                {item.last_track_data ? (
                                                    <>
                                                        <p className="tracked-date">{item.last_track_data}</p>
                                                        <p className="tracked-ago">{item.last_track_data_ago}</p>
                                                    </>
                                                ) : (
                                                    "-"
                                                )}
                                            </td>
                                            {/* <td>-</td> */}
                                            {/* <td title={item.device_id}>{item.device_id}</td>
                                            <td title={item.device_os}>( {item.device_os} )</td> */}
                                               <td
                                                className={`status ${item.system_status.toLowerCase() === "online"
                                                    ? "green"
                                                    : item.system_status === "Yet to Track"
                                                        ? "yellow"
                                                        : "red"
                                                    }`}
                                            >
                                                {item?.system_status}
                                            </td>
                                            {/* <td className={item.emp_status.toLowerCase() === "active" ? "green" : "red"}>
                                                {item.emp_status}
                                            </td> */}
                                            {/* {showLastTracked && (
                                                <td title={formatLastActivity(item.last_track_activity)}>
                                                    {formatLastActivity(item.last_track_activity)}
                                                </td>
                                            )}
                                            {showLastScreenshot && (
                                                <td title={formatLastActivity(item.last_screenshot_time)}>
                                                    {formatLastActivity(item.last_screenshot_time)}
                                                </td>
                                            )} */}
                                        </tr>
                                    ))
                                ) : (
                                    <tr className="no-data-row">
                                        <td className="no-data"
                                        colSpan={8}
                                        //  colSpan={visibleColCount}
                                         >
                                            <div className="d-flex flex-column justify-content-center align-items-center">
                                                <Image src="/images/dashboard/user_icon.png" alt="No Data Found" />
                                                <p className="m-0" style={{ margin: "1.5rem !important", textAlign: "center" }}>
                                                    No users to show
                                                </p>
                                            </div>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {totalEmployees > 0 && (
                        <div className="d-flex justify-content-end mt-3">
                            <Pagination
                                className="employee-pagination"
                                current={current}
                                onChange={onPageChange}
                                total={totalEmployees}
                                showSizeChanger={false}
                            />
                        </div>
                    )}
                </div>
            )}

            {/* ── Tablet Filter Modal ── */}
            <Modal
                show={showFilterModal}
                onHide={handleModalCancel}
                centered
                className="tablet-filter-modal"
            >
                <Modal.Header>
                    <Modal.Title>Filter</Modal.Title>
                    <button className="modal-close-btn" onClick={handleModalCancel}>✕</button>
                </Modal.Header>
                <Modal.Body>
                    <FilterDropdown
                        id="department"
                        label="Department"
                        placeholder="Select Department"
                        options={tempDepartmentOptions}
                        setter={setTempDepartmentOptions}
                        optionKey="value"
                    />
                    <FilterDropdown
                        id="designation"
                        label="Designation"
                        placeholder="Select Designation"
                        options={tempDesignationOptions}
                        setter={setTempDesignationOptions}
                        optionKey="value"
                    />
                    <FilterDropdown
                        id="systemStatus"
                        label="Current Status"
                        placeholder="Select Status"
                        options={tempSystemStatus}
                        setter={setTempSystemStatus}
                        optionKey="filterValue"
                    />
                    <FilterDropdown
                        id="empStatus"
                        label="Emp Status"
                        placeholder="Select Status"
                        options={tempEmployeeStatus}
                        setter={setTempEmployeeStatus}
                        optionKey="filterValue"
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button className="modal-cancel-btn" onClick={handleModalCancel}>Cancel</Button>
                    <Button className="modal-apply-btn" onClick={handleModalApply}>Apply</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
};

export default EmployeeLasttracked;